// @ts-nocheck

import { useContext } from 'react';

import { MatchRouteContext } from '../contexts/MatchRouteContext';

const useMatchRouteContext = () => useContext(MatchRouteContext);

export default useMatchRouteContext;
